import Icon from '../components/Icon.vue'

Icon.register({
  archway: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M560 448H544V96H32V448H16C7.2 448 0 455.2 0 464V496C0 504.8 7.2 512 16 512H176C184.8 512 192 504.8 192 496V320C192 267 235 224 288 224S384 267 384 320L384 480V496C384 504.8 391.2 512 400 512H560C568.8 512 576 504.8 576 496V464C576 455.2 568.8 448 560 448zM560 0H16C7.2 0 0 7.2 0 16V48C0 56.8 7.2 64 16 64H560C568.8 64 576 56.8 576 48V16C576 7.2 568.8 0 560 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/archway.js
// module id = zffI
// module chunks = 144